// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"827":"603f9cdd","926":"151081a3"}[chunkId] + ".css";
};